import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  main: {
    position: 'relative',
    flex: 1,
    alignSelf: 'self-start',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& .uppy-Dashboard-inner': {
      border: `1px solid ${theme.palette.secondary.light}`,
      borderRadius: 8,
      background: '#FFF',
    },
    '& .uppy-Dashboard-browse': {
      color: theme.palette.primary.main,
    },

    '& .uppy-Dashboard-AddFiles': {
      borderColor: `${theme.palette.secondary.light}`,
      borderRadius: 8,
      alignItems: 'flex-start',
      paddingLeft: 'calc(96px + 47px + 16px)',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 16,
        paddingRight: 16,
        textAlign: 'center',
        justifyContent: 'flex-start',
        paddingTop: 'calc(87px + 12px)',
      },
    },
    '& .uppy-Dashboard-AddFiles-title': {
      fontFamily: theme.typography.fontFamily,
      fontStyle: 'normal',
      fontWeight: 300,
      fontSize: '14px',
      lineHeight: '16px',
      color: theme.palette.secondary.dark,
      textAlign: 'left',
      padding: 0,
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
  },
  inner: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: 1,
    padding: '20px 47px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pointerEvents: 'none',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      alignItems: 'flex-start',
      padding: '16px',
      paddingTop: 21,
    },
  },
  illustration: {
    height: 'auto',
    width: 95,
    [theme.breakpoints.down('sm')]: {
      wdith: 'auto',
      height: 87,
    },
  },
}))
